import { Col, View } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateFormatter } from '../../util/campaign/campaignUtils';
import TemplatePreview from '../molecules/TemplatePreview';

export const ReviewAndLaunch = () => {
  const formState = useSelector(store => store.campaign.campaignFormState);
  return (
    <>
      <Col gridGap="S300">
        <View>
          <Label>
            <FormattedMessage
              id="app.campaign.review.label.campaignName"
              defaultMessage="Campaign Name"
            />
          </Label>
          <Text>{formState.campaignDetails.campaignName ?? '-'}</Text>
        </View>
        <View>
          <Label>
            <FormattedMessage
              id="app.campaign.review.label.campaignDescription"
              defaultMessage="Campaign Description"
            />
          </Label>
          <Text>{formState.campaignDetails.campaignDescription ?? '-'}</Text>
        </View>
        <View>
          <Label>
            <FormattedMessage
              id="app.campaign.review.label.messageTemplate"
              defaultMessage="Message Template"
            />
          </Label>
          <TemplatePreview templateName={formState.templateDetails.messageTemplateName} />
        </View>
        <View>
          <Label>
            <FormattedMessage id="app.campaign.review.label.segment" defaultMessage="Segment" />
          </Label>
          <Text>{formState.segmentDetails.segmentName ?? '-'}</Text>
        </View>

        <View>
          <Label>
            <FormattedMessage
              id="app.campaign.review.label.channelType"
              defaultMessage="Channel Type"
            />
          </Label>
          <Text>{formState.campaignDetails.channelType ?? '-'}</Text>
        </View>
        <View>
          <Label>
            <FormattedMessage id="app.campaign.review.label.frequency" defaultMessage="Frequency" />
          </Label>
          <Text>{formState.campaignDetails.frequency ?? '-'}</Text>
        </View>
        <View>
          <Label>
            <FormattedMessage
              id="app.campaign.review.label.startTime"
              defaultMessage="Start Time"
            />
          </Label>
          <Text>{dateFormatter(formState.campaignDetails.startTime)}</Text>
        </View>
        <View>
          <Label>
            <FormattedMessage id="app.campaign.review.label.endTime" defaultMessage="End Time" />
          </Label>
          <Text>{dateFormatter(formState.campaignDetails.endTime)}</Text>
        </View>
        <View>
          <Label>
            <FormattedMessage id="app.campaign.review.label.timeZone" defaultMessage="Timezone" />
          </Label>
          <Text>{formState.campaignDetails.timeZone?.label ?? '-'}</Text>
        </View>
      </Col>
    </>
  );
};
